/**
 * ローディング シーン
 */
import {assets, soundAssets} from '../../../loader/_assets';
import AssetsLoader from '../../../loader/main';
import AudioPlayer from '../../../../../common/audio/main';



export default class Loading extends Phaser.Scene{

    
    constructor(){
        super({key: 'Game1Loading'});
    }


    /**
     * 読み込み処理 (LifeCycle Methods)
     */
    preload(){
        this.loader = new AssetsLoader(this);
        this.loader.load(assets.game1);
    }


    /**
     * シーン開始時処理 (LifeCycle Methods)
     */
    create(){
        GAME_REF.scene = this;

        const sound = new AudioPlayer(soundAssets.game1);
        sound.load()
            .then(() => {
                document.querySelector('.js-loader').classList.remove('-active');
                this.scene.stop();
                this.scene.start('Game1Playing');
                //this.scene.start('Game1Clear');
            })
            .catch((err) => {});
        GAME_REF.obj.sound = sound;
    }
}